module.exports = __webpack_public_path__ + "img/album14_39.e219406c.jpg";